import {combineReducers} from 'redux'
import leaderboardV2Reducer from './leaderboardV2_reducer'
import eventReducer from './event_reducer'
import detailsReducer from './details_reducer'
import memberSearchReducer from './member_search_reducer'
import summariesReducer from './summaries_reducer'
import toastReducer from './toast_reducer'

export default combineReducers({
  leaderboardV2: leaderboardV2Reducer,
  event: eventReducer,
  details: detailsReducer,
  memberSearch: memberSearchReducer,
  summaries: summariesReducer,
  toast: toastReducer,
})
